import React from "react";
import "./banner.scss"

const Banner = React.forwardRef((props, ref) => {
    return (
        <div ref={ref} className="banner-container">
            <span className="banner-container__heading">"Driving Innovation, Simplifying Solutions."</span>
            <span className="banner-container__sub-heading">At Bloobind, we craft intelligent software solutions designed to empower businesses and simplify processes. From startups to enterprises, we help you stay ahead with cutting-edge technology that fuels success.</span>
            <img className="banner-container__img" alt="banner" src={"/banner-images/banner-img.png"}></img>
        </div>
    )
});

export default Banner;